import { NgModule, ModuleWithProviders } from '@angular/core';
import { PershingCoreModule } from '@pershing/pershing-core';
import { LoginComponent } from './components/login.component';
import { PershingDisclaimerComponent } from './components/pershing-disclaimer.component';
import { NxpActionMenuComponent } from './components/nxp-action-menu.component';
import { PershingMessageComponent } from './components/pershing-message.component';
import { PershingMessageDialog } from './components/pershing-message-dialog.component';
import { PershingIFrameComponent } from './components/pershing-iframe.component';
import { PershingResponsiveComponent } from './components/pershing-responsive.component';
import { PershingModalComponent } from './components/pershing-modal.component';
import { PershingInputComponent } from './components/pershing-input.component';
import { PershingContentManagementComponent } from './components/pershing-content-management.component';
import { PershingModalService } from './services/pershing-modal.service';
import { ActionMenuService } from './services/action-menu.service';
import { ContentManagementService } from './services/content-management.service';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatOptionModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';
import { PershingComponent } from './components/pershing-wrapper.component';
import { PershingOverlayComponent } from './components/pershing-overlay.component';
import { PershingTooltipComponent } from './components/pershing-tooltip.component';
import { PershingConfirmationModalComponent } from './components/pershing-confirmation-modal.component';
import { PershingEscapeHtmlPipe } from './pipes/keep-html.pipe';
import {
    NguCarouselPointDirective,
    NguCarouselItemDirective,
    NguCarouselNextDirective,
    NguCarouselPrevDirective,
    NguCarouselDefDirective,
    NguCarouselOutlet
  } from '../lib/directives/ngu-carousel.directive';
import { NguItemComponent } from '../lib/components/ngu-item/ngu-item.component';
import { NguCarousel } from '../lib/components/ngu-carousel/ngu-carousel.component';
import { NguTileComponent } from '../lib/components/ngu-tile/ngu-tile.component';
//   import {
//     HammerGestureConfig,
//     HAMMER_GESTURE_CONFIG,
//     HammerModule
//   } from '@angular/platform-browser';

@NgModule({
    imports: [
        PershingCoreModule,
        MatButtonModule,
        MatInputModule,
        MatAutocompleteModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatMenuModule,
        MatOptionModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        ReactiveFormsModule
    ],
    declarations: [
        LoginComponent,
        PershingDisclaimerComponent,
        NxpActionMenuComponent,
        PershingMessageDialog,
        PershingMessageComponent,
        PershingIFrameComponent,
        PershingResponsiveComponent,
        PershingModalComponent,
        PershingInputComponent,
        PershingComponent,
        PershingOverlayComponent,
        PershingContentManagementComponent,
        PershingTooltipComponent,
        PershingConfirmationModalComponent,
        NguCarousel,
        NguItemComponent,
        NguTileComponent,
        NguCarouselPointDirective,
        NguCarouselItemDirective,
        NguCarouselNextDirective,
        NguCarouselPrevDirective,
        NguCarouselDefDirective,
        NguCarouselOutlet,
        PershingEscapeHtmlPipe
    ],
    exports: [
        LoginComponent,
        PershingDisclaimerComponent,
        NxpActionMenuComponent,
        PershingMessageDialog,
        PershingMessageComponent,
        PershingIFrameComponent,
        PershingResponsiveComponent,
        PershingModalComponent,
        PershingInputComponent,
        PershingComponent,
        PershingOverlayComponent,
        PershingContentManagementComponent,
        PershingTooltipComponent,
        PershingConfirmationModalComponent,
        NguCarousel,
        NguItemComponent,
        NguTileComponent,
        NguCarouselPointDirective,
        NguCarouselItemDirective,
        NguCarouselNextDirective,
        NguCarouselPrevDirective,
        NguCarouselDefDirective,
        NguCarouselOutlet
    ],
    entryComponents: [
        PershingMessageDialog,
        PershingComponent,
        PershingConfirmationModalComponent
    ]
})
export class PershingCommonModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: PershingCommonModule,
            providers: [
                PershingModalService,
                ActionMenuService,
                ContentManagementService
            ]
        };
    }
}
